import script from "./NavbarMain.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarMain.vue?vue&type=script&setup=true&lang=js"

import "./NavbarMain.vue?vue&type=style&index=0&id=a488915c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a488915c"]])

export default __exports__